<template>
  <div>
    <b-modal id="patient-modal" :title="modalData.title">
      <b-form-group id="label-input-first-name" label="Nombre*:" label-for="input-first-name">
        <b-form-input
          id="input-first-name"
          v-model="modalData.patientData.first_name"
          type="text"
          :state="modalData.patientData.first_name.length>0"
        />
      </b-form-group>
      <b-form-group id="label-input-last-name" label="Apellido*:" label-for="input-last-name">
        <b-form-input
          id="input-last-name"
          v-model="modalData.patientData.last_name"
          type="text"
          :state="modalData.patientData.last_name.length>0"
        />
      </b-form-group>
      <b-form-group id="label-input-rut" label="Rut:" label-for="input-rut">
        <b-form-input id="input-rut" v-model="modalData.patientData.rut" type="text" />
      </b-form-group>
      <b-form-group id="label-input-email" label="Email:" label-for="input-email">
        <b-form-input id="input-email" v-model="modalData.patientData.email" type="email" />
      </b-form-group>
      <template v-slot:modal-footer>
        <b-button size="sm" variant="info" @click="confirm()">{{modalData.confirmText}}</b-button>
        <b-button size="sm" variant="outline-info" @click="hide()">Cancelar</b-button>
      </template>
    </b-modal>
  </div>
</template>


<script>
// we must import our Modal plugin instance
// because it contains reference to our Eventbus
import PatientModal from "../../utils/patient-modal.js";

export default {
  data() {
    return {
      modalData: {
        title: "",
        patientData: {
          first_name: "",
          last_name: "",
          rut: "",
          email: "",
        },
        onConfirm: {},
        confirmText: ""
      }
    };
  },
  methods: {
    hide() {
      this.$bvModal.hide("patient-modal");
    },
    confirm() {
      // we must check if this.onConfirm is function
      if (typeof this.modalData.onConfirm === "function") {
        // run passed function and then close the modal
        let close = this.modalData.onConfirm(this.modalData.patientData);
        if (close) {
          this.$router.go();
        }
        this.$bvModal.hide("patient-modal");
      }
    },
    show(params) {
      // setting title and text
      this.modalData = params;
      this.$bvModal.show("patient-modal");
    }
  },
  beforeMount() {
    // here we need to listen for emited events
    // we declared those events inside our plugin
    PatientModal.EventBus.$on("show", params => {
      this.show(params);
    });
  }
};
</script>